import { Injectable } from '@angular/core';
import { CanActivateChild } from '@angular/router';

import { AuthGuard } from '../../core/services/auth/auth-guard.service';
import { UsuarioPerfil, usuarioPerfilAdministrador, usuarioPerfilAtendente, usuarioPerfilExpedicao, usuarioPerfilRepresentante, usuarioPerfilGerente } from '../usuario/usuario-perfil';


/** Acessos permitidos a tela de expedição */
export const acessosExpedicao: UsuarioPerfil[] = [usuarioPerfilAdministrador, usuarioPerfilAtendente, usuarioPerfilExpedicao, usuarioPerfilRepresentante, usuarioPerfilGerente];

@Injectable()
export class CanActivateExpedicao implements CanActivateChild {

    constructor(private authGuard: AuthGuard) { }

    canActivateChild(): boolean {
        return this.authGuard.canActivateAcesso(acessosExpedicao);
    }
}
